import { render, staticRenderFns } from "./myFans.vue?vue&type=template&id=64e06337&scoped=true&"
import script from "./myFans.vue?vue&type=script&lang=js&"
export * from "./myFans.vue?vue&type=script&lang=js&"
import style0 from "./myFans.vue?vue&type=style&index=0&id=64e06337&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e06337",
  null
  
)

export default component.exports